import axios from 'axios';
import resolvePath from 'utils/resolvePath';
import { store } from 'store/store';
// Action
const CLEAR = 'supportComments/clear';
const GET_SUPPORT_COMMENTS = 'supportComments/getSupportComments';
const GET_SUPPORT_COMMENTS_REQUEST = 'supportComments/getSupportCommentsRequest';
const GET_SUPPORT_COMMENTS_SUCCESS = 'supportComments/getSupportCommentsSuccess';
const GET_SUPPORT_COMMENTS_FAILURE = 'supportComments/getSupportCommentsFailure';
const POST_SUPPORT_COMMENTS_REQUEST = 'supportComments/postSupportCommentsRequest';
const POST_SUPPORT_COMMENTS_SUCCESS = 'supportComments/postSupportCommentsSuccess';
const POST_SUPPORT_COMMENTS_FAILURE = 'supportComments/postSupportCommentsFailure';
const PATCH_SUPPORT_COMMENTS_REQUEST = 'supportComments/patchSupportCommentsRequest';
const PATCH_SUPPORT_COMMENTS_SUCCESS = 'supportComments/patchSupportCommentsSuccess';
const PATCH_SUPPORT_COMMENTS_FAILURE = 'supportComments/patchSupportCommentsFailure';
// Action Creator
export const clear = () => {
    return {
        type: CLEAR,
    };
};
export const getSupportCommentsRequest = () => {
    return {
        type: GET_SUPPORT_COMMENTS_REQUEST,
    };
};
export const getSupportCommentsSuccess = (comment) => {
    return {
        payload: {
            comment,
        },
        type: GET_SUPPORT_COMMENTS_SUCCESS,
    };
};
export const getSupportCommentsFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_SUPPORT_COMMENTS_FAILURE,
    };
};
export const getSupportComments = (authToken, userId) => {
    const loadSupportComments = (dispatch) => {
        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        };
        return axios
            .get(resolvePath.api(`support_comments/${userId}`), config)
            .then((response) => dispatch(getSupportCommentsSuccess(response.data)))
            .catch((error) => {
            dispatch(getSupportCommentsFailure(error));
            throw error;
        });
    };
    loadSupportComments(store.dispatch);
    return {
        type: GET_SUPPORT_COMMENTS,
    };
};
export const postSupportCommentsRequest = () => {
    return {
        type: POST_SUPPORT_COMMENTS_REQUEST,
    };
};
export const postSupportCommentsSuccess = (comment) => {
    return {
        payload: {
            comment,
        },
        type: POST_SUPPORT_COMMENTS_SUCCESS,
    };
};
export const postSupportCommentsFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: POST_SUPPORT_COMMENTS_FAILURE,
    };
};
export const postSupportComments = (authToken, userId, comment) => (dispatch) => {
    dispatch(postSupportCommentsRequest());
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    const request = {
        user_id: userId,
        comment,
    };
    return axios
        .post(resolvePath.api('support_comments'), request, config)
        .then((respone) => dispatch(postSupportCommentsSuccess(respone.data)))
        .catch((error) => {
        dispatch(postSupportCommentsFailure(error));
        throw error;
    });
};
export const patchSupportCommentsRequest = () => {
    return {
        type: POST_SUPPORT_COMMENTS_REQUEST,
    };
};
export const patchSupportCommentsSuccess = (comment) => {
    return {
        payload: {
            comment,
        },
        type: POST_SUPPORT_COMMENTS_SUCCESS,
    };
};
export const patchSupportCommentsFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: POST_SUPPORT_COMMENTS_FAILURE,
    };
};
export const patchSupportComments = (authToken, userId, comment) => (dispatch) => {
    dispatch(patchSupportCommentsRequest());
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    const request = {
        comment,
    };
    return axios
        .patch(resolvePath.api(`support_comments/${userId}`), request, config)
        .then((respone) => dispatch(patchSupportCommentsSuccess(respone.data)))
        .catch((error) => {
        dispatch(patchSupportCommentsFailure(error));
        throw error;
    });
};
const initialState = {
    error: null,
    comment: '',
};
export default (state = initialState, action) => {
    switch (action.type) {
        case CLEAR: {
            return Object.assign(Object.assign({}, state), { comment: '' });
        }
        case GET_SUPPORT_COMMENTS_REQUEST: {
            return Object.assign({}, state);
        }
        case GET_SUPPORT_COMMENTS_SUCCESS: {
            return Object.assign(Object.assign({}, state), { comment: action.payload.comment });
        }
        case GET_SUPPORT_COMMENTS_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error });
        }
        case POST_SUPPORT_COMMENTS_REQUEST: {
            return Object.assign({}, state);
        }
        case POST_SUPPORT_COMMENTS_SUCCESS: {
            return Object.assign(Object.assign({}, state), { comment: action.payload.comment });
        }
        case POST_SUPPORT_COMMENTS_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error });
        }
        case PATCH_SUPPORT_COMMENTS_REQUEST: {
            return Object.assign({}, state);
        }
        case PATCH_SUPPORT_COMMENTS_SUCCESS: {
            return Object.assign(Object.assign({}, state), { comment: action.payload.comment });
        }
        case PATCH_SUPPORT_COMMENTS_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error });
        }
        default: {
            return state;
        }
    }
};
